'use strict';

(function () {
  'use strict';

  angular.module('msGoals').component('msCalendar', {
    bindings: {
      calendarData: '<',
      monthShift: '<'
    },
    templateUrl: 'goals/templates/calendar.html',
    controller: CalendarController
  });

  CalendarController.$inject = [];

  function CalendarController() {
    var vm = this;
    var thisDate = void 0;
    vm.checkForEntries = checkForEntries;
    vm.shortDaysOfWeek = moment.weekdaysShort();

    vm.$onInit = function () {
      thisDate = moment().add(vm.monthShift, 'months');
    };

    /////////// Public Functions //////////////
    vm.$onChanges = function () {
      if (vm.calendarData.length === 0) {
        return;
      }
      _.each(vm.calendarData, function (t) {
        if (!t.data) {
          t.data = [];
        }
      });
      thisDate = moment().add(vm.monthShift, 'months');
      plotItAll();
    };

    vm.expandDateDetail = function (selectedColumn, selectedRow, calendarRecords) {
      if (!vm.checkForEntries(calendarRecords)) {
        vm.selectedDate = {
          column: undefined,
          row: undefined
        };
      } else {
        vm.selectedDate = {
          column: selectedColumn,
          row: selectedRow
        };
      }
    };

    /////////// Private Functions //////////////

    function plotItAll() {

      // Calendar Month Plot
      var calendarData = createCalendarMonthLabels(thisDate);
      vm.plottableMonthLabels = calendarData.monthLabels;
      vm.chartJSToolTipLabels = calendarData.tooltipLabels;
      vm.plottableMonthData = plotMonthlyCalendarData(vm.calendarData, thisDate);
      vm.monthDaysData = getDaysArrayByMonth();
    }
  }

  function getDaysArrayByMonth() {
    var arrDays = [];
    var daysInMonth = moment().daysInMonth();

    while (daysInMonth) {
      var current = moment().date(daysInMonth);
      arrDays.push(current);
      daysInMonth--;
    }

    return arrDays.reverse();
  }

  function checkForEntries(calendarRecords) {
    var notEmptyEntries = calendarRecords.filter(function (record) {
      return !_.isNull(record.value) && !_.isUndefined(record.value);
    });
    return notEmptyEntries.length !== 0;
  }

  function createChartJSMonthLabels(thisDate) {
    var chartJSLabels = [];
    var tooltipLabels = [];
    var thisMonthShortName = moment(thisDate).format('MMM');

    for (var d = 1; d < moment(thisDate).daysInMonth() + 1; d++) {
      var dayNumber = moment(thisDate).date(d).format('D');
      chartJSLabels.push(dayNumber);
      tooltipLabels.push(thisMonthShortName + ' ' + moment(thisDate).date(d).format('Do'));
    }
    return { chartLabels: chartJSLabels, tooltipLabels: tooltipLabels };
  }

  // Average all the values on the same day together.
  function averageDayValues(calendarData) {
    var uniqueDates = {};

    calendarData.forEach(function (datapoint) {

      // If we've got timestamp, create moment object
      if (!angular.isObject(datapoint.datetime)) {
        datapoint.datetime = moment(datapoint.datetime);
      }

      // If this datapoint's date is the first of its kind, create a new object.
      if (!_.has(uniqueDates, datapoint.datetime.date())) {
        uniqueDates[datapoint.datetime.date()] = {
          values: [datapoint.value],
          datetimes: [datapoint.datetime],
          messages: [datapoint.message]
        };
      }
      // If we've seen this date before, save the values.
      else {
          uniqueDates[datapoint.datetime.date()].values.push(datapoint.value);
          uniqueDates[datapoint.datetime.date()].datetimes.push(datapoint.datetime);
          uniqueDates[datapoint.datetime.date()].messages.push(datapoint.message);
        }
    });

    // Average all the values and times together, remove empty messages.
    _.map(uniqueDates, function (dayValues, date) {

      uniqueDates[date] = {
        value: numAverage(dayValues.values),
        messages: _.compact(dayValues.messages),
        datetime: datesAverage(dayValues.datetimes)
      };
    });

    return _.values(uniqueDates);
  }

  function numAverage(arr) {
    return _.reduce(arr, function (memo, num) {
      return memo + num;
    }, 0) / (arr.length === 0 ? 1 : arr.length);
  }

  function datesAverage(arr) {
    var startDate = arr.sort()[0];
    var totalDiff = _.reduce(arr, function (memo, date) {
      return memo + moment(startDate).diff(moment(date));
    }, 0) / (arr.length === 0 ? 1 : arr.length);
    return moment(startDate).clone().subtract(totalDiff);
  }

  // Adds padding to a calendar week's worth of data.
  function padWeekOfCalendarData(calendarWeekOfEntries) {

    // I might want to revisit this, but the data array needs at least one empty object
    // to get any padding. Easy fix.
    if (calendarWeekOfEntries.length === 0) {
      calendarWeekOfEntries = [{}];
    }
    var paddedDataset = [];

    var weekOfPadding = createPaddedWeekOfData();

    // For each day of the week...
    weekOfPadding.forEach(function (paddedDataPoint, d) {

      calendarWeekOfEntries.forEach(function (dataPoint) {

        // If the datetime for the entry matches the day we want (coincides with the column the point gets placed in).
        // `d` is the day of the week, in numbers.
        if (moment(dataPoint.datetime).day() === d) {
          paddedDataset[d] = dataPoint;
        }

        // If the datetime for the entry doesn't match, pad the dataset with an empty entry.
        // Only add padding if there is no data value for the current day of the week (d)
        else if (!paddedDataset[d] && moment(dataPoint.datetime).isSame(moment(), 'month')) {
            paddedDataset[d] = paddedDataPoint;
          }
      });
    });

    return paddedDataset;
  }

  function createPaddedWeekOfData() {
    var weekOfPadding = [];
    var startDate = 0;
    var currentDate = moment().day(startDate);

    // The padded datapoint uses a new Moment using the day of the week index.
    // Because of the way Moment.js works, the actual date is always going to be from this calendar week,
    // not the actual date that it will correspond to in the calendar.
    // This doesn't matter, because the `datetime` property isn't used in the calendar view;
    // it's just padding for ngRepeat.

    weekOfPadding.push({
      datetime: currentDate.valueOf(),
      value: null
    });
    currentDate = moment(currentDate).add(1, 'days');

    while (currentDate.day() !== 0) {
      weekOfPadding.push({
        datetime: currentDate.valueOf(),
        value: null
      });
      currentDate = moment(currentDate).add(1, 'days');
    }

    return weekOfPadding;
  }

  function filterForGivenWeekOfYear(calendarData, weekOfYear, thisDate) {
    return calendarData.filter(function (datapoint) {
      return moment(datapoint.datetime).week() === weekOfYear && moment(datapoint.datetime).month() === moment(thisDate).month();
    });
  }

  function filterAndPadcalendarDataByCalendarWeek(calendarObject, thisDate) {

    var startWeekOfYear = moment(thisDate).startOf('month').add(1, 'second');
    var endWeekOfYear = moment(thisDate).locale('en').endOf('month');
    startWeekOfYear = startWeekOfYear.locale('en').week();
    endWeekOfYear = endWeekOfYear.locale('en').week();

    // If the last week of the month is the first week of the next year (happens in December), we need to apply some custom rules.
    if (moment(thisDate).endOf('month').week() === 1 && _.includes([52, 53], moment(thisDate).endOf('month').isoWeek())) {
      endWeekOfYear = moment(thisDate).endOf('month').isoWeek();
    }
    if (moment(thisDate).endOf('month').week() === 1 && moment(thisDate).endOf('month').weeksInYear() === moment(thisDate).endOf('month').isoWeeksInYear()) {
      endWeekOfYear = 53;
    }

    var transformedMonthData = [];
    calendarObject.data = averageDayValues(calendarObject.data);

    for (var weekOfGrid = startWeekOfYear; weekOfGrid <= endWeekOfYear; weekOfGrid++) {

      // Remove any data outside of the week and month we are concerned about.
      var filteredDataForWeek = filterForGivenWeekOfYear(calendarObject.data, weekOfGrid, thisDate);

      // Fill in the gaps for the week.
      filteredDataForWeek = padWeekOfCalendarData(filteredDataForWeek);

      transformedMonthData.push(filteredDataForWeek);
    }
    return transformedMonthData;
  }

  function plotMonthlyCalendarData(arrayOfcalendars, thisDate) {

    var monthsData = [];

    // Loop through the list of calendars
    arrayOfcalendars.forEach(function (calendarData) {

      // Copy the data over so we don't ruin Angular's original.
      var calendarDataCopy = filterAndPadcalendarDataByCalendarWeek(angular.copy(calendarData), thisDate);

      // Loop through each WEEK of the calendar's data
      calendarDataCopy.forEach(function (arrayOfWeeksData, weekOfMonth) {

        // Loop through each DAY of the calendar's data
        arrayOfWeeksData.forEach(function (dataPoint, dayOfWeekIndex) {
          var datapointTransformed = {
            value: dataPoint.value,
            datetime: dataPoint.datetime,
            title: calendarData.title,
            color: '#46944b'
          };

          // This creates an array for the day (if it does not already exist), and pushes
          // a new datapoint to it.
          monthsData[weekOfMonth] = monthsData[weekOfMonth] || [];
          monthsData[weekOfMonth][dayOfWeekIndex] = monthsData[weekOfMonth][dayOfWeekIndex] || [];

          monthsData[weekOfMonth][dayOfWeekIndex].push(datapointTransformed);
        });
        // End DAY loop
      });
      // End WEEK loop
    });
    // End vm.calendarData.forEach
    return monthsData;
  }

  function createCalendarMonthLabels(thisDate) {

    var plottableMonthLabels, plottableMonthData;

    var firstDayOfMonth = moment(thisDate).startOf('month');
    var firstDayOfGrid = firstDayOfMonth.startOf('week');
    var lastDayOfMonth = moment(thisDate).endOf('month');
    var lastDayOfGrid = lastDayOfMonth.endOf('week').endOf('day');
    var weeksOnGrid = lastDayOfGrid.week() - firstDayOfGrid.week() + 1;

    if (weeksOnGrid < 0) {
      weeksOnGrid = firstDayOfGrid.week() - lastDayOfGrid.week() + 1;
    }

    // Make an array of numbers for each of the month's days.
    var monthLabels = [];
    for (var d = 1; d <= moment(thisDate).daysInMonth(); d++) {
      monthLabels.push(d);
    }
    // Now add some 0's to the beginning and end to complete the week.
    // Each week needs 7days, but the bookends aren't always in the month.
    var firstWeekOnCalendar = thisDate.startOf('month').day();
    var lastWeekOnCalendar = thisDate.endOf('month').day();
    var endPaddingLength = 6 - lastWeekOnCalendar;
    var startPaddingLength = firstWeekOnCalendar;
    var endPadding = [];
    var startPadding = [];

    for (var i = 0; i < endPaddingLength; i++) {
      endPadding.push(0);
    }
    for (var j = 0; j < startPaddingLength; j++) {
      startPadding.push(0);
    }

    monthLabels = monthLabels.concat(endPadding);
    monthLabels = startPadding.concat(monthLabels);

    // Create these arrays to hold data separated out for each week.
    plottableMonthLabels = [];
    plottableMonthLabels.length = weeksOnGrid;
    plottableMonthData = [];
    plottableMonthData.length = weeksOnGrid;

    // Create labels for the Calendar (the days in the corner)
    for (var weekOfGrid = 0; weekOfGrid < weeksOnGrid; weekOfGrid++) {
      // Separate out the month's days by week for labeling the data.
      plottableMonthLabels[weekOfGrid] = monthLabels.slice(7 * weekOfGrid, 7 * weekOfGrid + 7);
    }
    return { monthLabels: plottableMonthLabels, monthData: plottableMonthData, tooltipLabels: createChartJSMonthLabels(thisDate).tooltipLabels };
  }
})();